import { Button, Space, Table, Pagination, Flex, Select, Popconfirm, message, Tag, Typography } from "antd";
import { useEffect, useState } from "react";
import { useDebouncedCallback } from "use-debounce";
import { PlusOutlined } from "@ant-design/icons";
import { deleteAIPrompt, fetchAIPrompts } from "../../api/ai";
import AIPromptEditModalView from "../../components/ai/prompt_edit_modal_view";

export const PromptCategoryOptions = Object.freeze(['TickersGenerationQuestion', 'TickersSuggestedQuestion', 'StockScreener', 'SecFillings', 'EconomicCalendar', 'EarningCalendar'])

const AISystemPromptScreen = () => {
    const [modalOpen, setModalOpen] = useState(false);
    const [currPrompt, setCurrPrompt] = useState(null);
    const categories = PromptCategoryOptions.map(item => {
        return {
            key: item,
            label: item, 
            value: item
        }
    });

    const tabCols = [
        {
            title: 'Index',
            dataIndex: 'id',
            key: 'id',
            render: (text, _, index) => ((pageNum - 1) * pageSize + index + 1)
        },
        {
            title: 'User Prompt',
            dataIndex: 'description',
            key: 'description',
            render: (text, record) => {
                if(!text) return '';
                return <Typography.Text copyable>{text}</Typography.Text>;
            },
        },
        {
            title: 'System Prompt',
            dataIndex: 'systemPrompt',
            key: 'systemPrompt',
            render: (text, record) => {
                return <Typography.Text copyable>{text}</Typography.Text>;
            },
        },
        {
            title: 'Category',
            dataIndex: 'promptCategory',
            key: 'promptCategory',
            render: (text, _) => {
                return <Tag>{text}</Tag>
            },
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => {
                return (
                    <Button.Group size="small">
                        <Button type='link' onClick={() => { editHandle(record) }}>Edit</Button>
                        <Popconfirm
                            title="Delete Action"
                            description="Are you sure to delete this prompt?"
                            onConfirm={() => { deleteHandle(record) }}
                            okText="Yes"
                            cancelText="No" >
                            <Button danger type='link'>Delete</Button>
                        </Popconfirm>
                    </Button.Group>
                )
            },
        }
    ];

    const [searchParams, setSearchParams] = useState({
        promptCategory: null
    });

    const [tabData, setTabData] = useState([]);
    const [pageNum, setPageNum] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchData(pageNum, pageSize, searchParams);
    }, []);

    const fetchData = (pNum, pSize, search) => {
        setLoading(true);
        let params = {
            'page.num': pNum,
            'page.size': pSize,
            ...search,
        };
        fetchAIPrompts(params).then(res => {
            if (res.page) {
                setTotal(res.page.total);
            }
            if (res.list) {
                setTabData(res.list);
            }
        }).finally(() => setLoading(false))
    }

    const pageChange = (page, size) => {
        setPageNum(page);
        setPageSize(size);
        fetchData(page, size, searchParams);
    }

    const onSearchChange = useDebouncedCallback(
        (tag, value) => {
            let newParams = { ...searchParams };
            newParams[tag] = value;
            setSearchParams(newParams);
            setPageNum(1);
            fetchData(1, pageSize, newParams);
        },
        300
    )

    const createNewPrompt = () => {
        setCurrPrompt(null);
        setModalOpen(true);
    }

    const deleteHandle = (item) => {
        setLoading(true);
        deleteAIPrompt(item.id).then(res => {
            setLoading(false);
            fetchData(pageNum, pageSize, searchParams);
        }).catch(err => {
            setLoading(false);
            message.error(String(err));
        })
    }

    const editHandle = (item) => {
        setCurrPrompt(item);
        setModalOpen(true);
    }

    return (
        <div className='main-wrapper'>
            <div className='top-part cnt-item'>
                <Flex justify='space-between'>
                    <Button type='primary' icon={<PlusOutlined />} onClick={createNewPrompt}>Create Prompt</Button>
                    <Space>
                        <Select
                            style={{ width: 300 }}
                            options={categories}
                            placeholder='select category...'
                            onChange={value => onSearchChange('promptCategory', value)}
                            allowClear
                        />
                    </Space>
                </Flex>
            </div>
            <div className='cnt-item'>
                <Table
                    scroll={{ x: true }}
                    loading={loading}
                    rowKey={(record) => record.id}
                    rowClassName={'table-row'}
                    size='small'
                    dataSource={tabData}
                    columns={tabCols}
                    pagination={false}
                    expandable={{ rowExpandable: (record) => false, showExpandColumn: false }} />
            </div>
            <div className='footer-part cnt-item'>
                <Pagination
                    total={total}
                    showTotal={(total) => `total ${total}`}
                    current={pageNum}
                    pageSize={pageSize}
                    showSizeChanger={true}
                    pageSizeOptions={[10, 20, 30, 50]}
                    onChange={(page, size) => pageChange(page, size)}
                />
            </div>

            <AIPromptEditModalView
                open={modalOpen}
                categories={categories}
                defaultPrompt={currPrompt}
                onClose={() => setModalOpen(false)}
                onUpdate={() => {
                    fetchData(pageNum, pageSize, searchParams);
                }} />
        </div>
    )
}

export default AISystemPromptScreen;